module.exports = __webpack_public_path__ + "static/media/03-banner-04-polanco-mobile@2x.8391d56f.jpg";